import React, { Component } from 'react';
import Formulario from './AltaForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Alta extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, getModulo, listarColaborador, leer,
        limpiarDatos } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
        listarColaborador();
        limpiarDatos();
    }
    
    render(){
        const { loader, modulo, emp, registroAlta, tipo, suspension,
            datosColaborador, cargo, modificarAlta, fechaS } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    emp = {emp}
                    registroAlta = {registroAlta}
                    cargo = {cargo}
                    tipo = {tipo}
                    modificarAlta = {modificarAlta}
                    datosColaborador = {datosColaborador}
                    fechaS = {fechaS}
                    suspension = {suspension}
                />
            </LoadMask>
        );
    }
}

export default Alta;